import apiClient from "./apiClient";

// history entry types
export const getHistoryEntryTypes = (page = 1, limit = 30, sort = 'id', order = 'asc') => apiClient
    .get("/history-entry-types", { params: { page, limit, sort, order } })
    .then(res => res);
export const createHistoryEntryType = (data) => apiClient.post("/history-entry-types", data);
export const updateHistoryEntryType = (id, data) => apiClient.put(`/history-entry-types/${id}`, data);
export const deleteHistoryEntryType = (id) => apiClient.delete(`/history-entry-types/${id}`);

// histories
export const getHistories = (page = 1, limit = 30) => apiClient
    .get("/histories", { params: { page, limit } })
    .then(res => res);
export const getHistoriesByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/histories/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getHistoryById = (id) => apiClient.get(`/histories/${id}`);
export const createHistory = (data) => apiClient.post("/histories", data);
export const addAttachmentToHistory = (id, data) => apiClient.post(`/histories/${id}/attachments`, data);
export const updateHistory = (id, data) => apiClient.put(`/histories/${id}`, data);
export const removeAttachmentFromHistory = (id, attachmentId) => apiClient.delete(`/histories/${id}/attachments/${attachmentId}`);
export const deleteHistory = (id) => apiClient.delete(`/histories/${id}`);

// history entries
export const getHistoryEntries = (page = 1, limit = 30) => apiClient
    .get("/history-entries", { params: { page, limit } })
    .then(res => res);
export const getHistoryEntriesByHistoryId = (id, page = 1, limit = 30) => apiClient
    .get(`/history-entries/history/${id}`, { params: { page, limit } })
    .then(res => res);
export const getHistoryEntriesByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/history-entries/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getHistoryEntryById = (id) => apiClient.get(`/history-entries/${id}`);
export const createHistoryEntry = (data) => apiClient.post("/history-entries", data);
export const addAttachmentToHistoryEntry = (id, data) => apiClient.post(`/history-entries/${id}/attachments`, data);
export const updateHistoryEntry = (id, data) => apiClient.put(`/history-entries/${id}`, data);
export const removeAttachmentFromHistoryEntry = (id, attachmentId) => apiClient.delete(`/history-entries/${id}/attachments/${attachmentId}`);
export const deleteHistoryEntry = (id) => apiClient.delete(`/history-entries/${id}`);

// posts
export const createPost = (data) => apiClient.post("/posts", data);
export const updatePost = (id, data) => apiClient.put(`/posts/${id}`, data);
export const deletePost = (id) => apiClient.delete(`/posts/${id}`);

// vitals
export const getVitalsByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/vitals/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getVitalsByHistorytId = (id, page = 1, limit = 30) => apiClient
    .get(`/vitals/history/${id}`, { params: { page, limit } })
    .then(res => res);
export const getVitalsByHistoryEntrytId = (id, page = 1, limit = 30) => apiClient
    .get(`/vitals/history-entry/${id}`, { params: { page, limit } })
    .then(res => res);
export const getVitalsById = (id) => apiClient.get(`/vitals/${id}`);
export const createVitals = (data) => apiClient.post("/vitals", data);
export const updateVitals = (id, data) => apiClient.put(`/vitals/${id}`, data);
export const deleteVitals = (id) => apiClient.delete(`/vitals/${id}`);

// waiver templates
export const getWaiverTemplates = (page = 1, limit = 30, sort = 'id', order = 'asc') => apiClient
    .get("/waiver-templates", { params: { page, limit, sort, order } })
    .then(res => res);
export const createWaiverTemplate = (data) => apiClient.post("/waiver-templates", data);
export const updateWaiverTemplate = (id, data) => apiClient.put(`/waiver-templates/${id}`, data);
export const deleteWaiverTemplate = (id) => apiClient.delete(`/waiver-templates/${id}`);

// waivers
export const getWaivers = (page = 1, limit = 30, sort = 'id', order = 'asc') => apiClient
    .get("/waivers", { params: { page, limit, sort, order } })
    .then(res => res);
export const getWaiversByPetId = (id, page = 1, limit = 30) => apiClient
    .get(`/waivers/pet/${id}`, { params: { page, limit } })
    .then(res => res);
export const getWaiversByHistorytId = (id, page = 1, limit = 30) => apiClient
    .get(`/waivers/history/${id}`, { params: { page, limit } })
    .then(res => res);
export const getWaiversByHistoryEntrytId = (id, page = 1, limit = 30) => apiClient
    .get(`/waivers/history-entry/${id}`, { params: { page, limit } })
    .then(res => res);
export const getWaiverById = (id) => apiClient.get(`/waivers/${id}`);
export const createWaiver = (data) => apiClient.post("/waivers", data);
export const updateWaiver = (id, data) => apiClient.put(`/waivers/${id}`, data);
export const deleteWaiver = (id) => apiClient.delete(`/waivers/${id}`);